import type { Screen } from "../App";
import { ROLE_LABEL, type SessionUser } from "../lib/roles";

interface NavItem {
  key: Screen;
  label: string;
}

const ITEMS: NavItem[] = [
  { key: "initiatives", label: "施策" },
  { key: "dashboard", label: "ダッシュボード" },
  { key: "campaigns", label: "キャンペーン" },
  { key: "review", label: "レビュー" },
  { key: "analytics", label: "分析" },
  { key: "mall-ads", label: "モール広告" },
  { key: "pl", label: "P/L" },
  { key: "amazon", label: "Amazon商品" },
  { key: "line-analytics", label: "LINE分析" },
  { key: "gifting", label: "ギフティング" },
];

const SOON_ITEMS: string[] = [];

interface SidebarProps {
  screen: Screen;
  onSelect: (s: Screen) => void;
  pendingCount: number;
  mobileOpen: boolean;
  onCloseMobile: () => void;
  /** 役割で許された画面だけを出す（出し分けは見た目のみ。API の遮断は BFF 側） */
  screens: readonly Screen[];
  user: SessionUser | null;
  onLogout: () => void;
}

export function Sidebar({ screen, onSelect, pendingCount, mobileOpen, onCloseMobile, screens, user, onLogout }: SidebarProps) {
  const items = ITEMS.filter((item) => screens.includes(item.key));
  return (
    <nav className={`sidebar ${mobileOpen ? "mobile-open" : ""}`} aria-label="メインナビゲーション">
      <div className="sidebar-brand">STOQ広告管理コンソール</div>
      {items.map((item) => (
        <button
          key={item.key}
          className={`nav-btn ${screen === item.key ? "active" : ""}`}
          onClick={() => {
            onSelect(item.key);
            onCloseMobile();
          }}
        >
          {item.label}
          {item.key === "review" && pendingCount > 0 && (
            <span className="badge-count">{pendingCount}</span>
          )}
        </button>
      ))}
      {SOON_ITEMS.map((label) => (
        <button key={label} className="nav-btn" disabled>
          {label}
          <span className="badge-soon">準備中</span>
        </button>
      ))}
      {user && (
        <div className="sidebar-foot" data-role={user.role}>
          <div className="sidebar-user" title={`${user.name}（${ROLE_LABEL[user.role]}）としてログイン中`}>
            <span className="sidebar-user-avatar" aria-hidden="true">
              {user.name.slice(0, 1)}
            </span>
            <span className="sidebar-user-text">
              <span className="sidebar-user-name">{user.name}</span>
              <span className="sidebar-user-role">{ROLE_LABEL[user.role]}</span>
            </span>
          </div>
          <button type="button" className="btn btn-sm sidebar-logout" onClick={onLogout}>
            ログアウト
          </button>
        </div>
      )}
    </nav>
  );
}
